/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import {
  Component, Inject, Input, OnInit,
} from '@angular/core';
import { EditorDialogService } from 'src/ckeditor/editor/services/editor-dialog.service';
import { TranslationService } from '../../../common/translation.service';

@Component({
  selector: 'bulb-image-carousel-caption',
  templateUrl: './image-carousel-caption.component.html',
  standalone: false,
})
export class ImageCarouselCaptionComponent implements OnInit {
  /**
   * The asset of the image caption to display.
   */
  @Input() caption: any;

  /**
   * updated caption text to display.
   */
  captionText: string;

  /**
   * contains the translated text of confirm image carousel caption dialog button.
   */
  dialogConfirmBtnText: string;

  /**
   * If the page is editable.
   */
  editable: boolean;

  /**
   *Default Constructor.
   *
   * @param $translate Our Angular Translation service.
   * @param BulbPageService Our BulbPageService AngularJS service.
   * @param editorDialogService our cke dialog service.
   */
  constructor(
    private $translate: TranslationService,
    private editorDialogService: EditorDialogService,
    @Inject('BulbPageService') private bulbPageService: any,
  ) { }

  ngOnInit() {
    this.editable = this.bulbPageService.page?.editing;
    this.updateCaption();
    this.dialogConfirmBtnText = this.$translate.translateInstant('editor_image_carousel_caption_button');
  }

  /**
   * Method to set the value of caption text whether it is provided or not.
   */
  updateCaption() {
    if (this.caption) {
      this.caption = this.decodeHtmlCharCodes(this.caption);
      this.captionText = this.caption;
    } else {
      this.captionText = this.editable ? this.$translate.translateInstant('editor_image_caption_placeholder') : '';
    }
  }

  /**
   * Method to open dialog for caption.
   * @param event contains click event information.
   */
  openCaptionDialog(event) {
    if (this.editable) {
      const selectedCaption = $(event.target);
      const figure = selectedCaption.parents('[bulb-block-id]');
      const bulbBlockId = figure.attr('bulb-block-id');
      this.editorDialogService.showCaptionDialog(this.caption, bulbBlockId, this.dialogConfirmBtnText);
    }
  }

  /**
   * Decode Special Characters used in Image Block caption
   * @param str - String to be decoded.
   * @returns {string} String - decoded string.
   */
  decodeHtmlCharCodes(str) {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return doc.documentElement.textContent;
  }
}
